import React, { useState } from 'react'
import styled from 'styled-components'

import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { Input, Select, Button } from '@baseV2'
import { strings } from '@constants'
import { allowNumericKeyDown } from '@utils'
import { Spacings } from '@styles'

const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
	padding: ${Spacings.SPACING_4B};
`

const Footer = styled(DrawerFooterWrapper)`
	display: flex;
	/* Base DrawerFooterWrapper is row-reverse, which flips flex-end to the left — force row so the
	   Save button sits on the right. */
	flex-direction: row;
	justify-content: flex-end;
	gap: ${Spacings.SPACING_3B};
`

// Vehicle capacity (MT) dropdown options.
const VEHICLE_CAPACITY_OPTIONS = [10, 12, 16, 20, 22, 25, 28, 30, 32, 35, 40, 42, 43].map((v) => ({
	label: String(v),
	value: v,
}))

// Add / edit a vehicle (capacity + count). Rendered inside the global drawer.
const VehicleDetailForm = ({ vehicle, callbackFunction }) => {
	const [form, setForm] = useState({ capacity: vehicle?.capacity ?? '', count: vehicle?.count ?? '' })

	const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }))

	const save = () => {
		callbackFunction?.({ capacity: Number(form.capacity), count: Number(form.count) })
	}

	return (
		<>
			<DrawerBodyWrapper>
				<FormWrapper>
					<Select
						id='vehicle-capacity'
						label='Vehicle Capacity (MT)'
						placeholder='Select Vehicle Capacity (MT)'
						data={VEHICLE_CAPACITY_OPTIONS}
						displayKey='label'
						primaryKey='value'
						value={VEHICLE_CAPACITY_OPTIONS.find((o) => o.value === Number(form.capacity)) ?? {}}
						onChange={(item) => setField('capacity', item?.value)}
					/>
					<Input
						id='vehicle-count'
						type='number'
						label='Vehicle Count'
						placeholder='Enter Vehicle Count'
						value={form.count}
						onKeyDown={allowNumericKeyDown}
						onChange={(e) => setField('count', e.target.value)}
					/>
				</FormWrapper>
			</DrawerBodyWrapper>
			<Footer>
				<Button color='primary' onClick={save} disabled={!form.capacity || !form.count}>
					{strings('save')}
				</Button>
			</Footer>
		</>
	)
}

export default VehicleDetailForm
